import {css} from "lit-element/lit-element.js";
export default css`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-icon,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
:host([alignment=left]),
.text-align-left {
  text-align: left;
}

:host([alignment=center]),
.text-align-center {
  text-align: center;
}

:host([alignment=right]),
.text-align-right {
  text-align: right;
}

:host([alignment=justify]),
.text-align-justify {
  text-align: justify;
}

.text-muted {
  color: #687078 !important;
}

.text-white {
  color: #ffffff !important;
}

:host([ellipsis]) {
  width: 100%;
  overflow: hidden;
}

.ellipsis {
  display: block !important;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.line-clamp {
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

:host {
  display: block;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

.atlas-display {
  font-weight: 300;
  line-height: 1.2;
  color: #212529;
}

.display1 {
  font-size: 6rem;
}
.display1.skeleton {
  height: 7.2rem;
}

.display2 {
  font-size: 5.5rem;
}
.display2.skeleton {
  height: 6.6rem;
}

.display3 {
  font-size: 4.5rem;
}
.display3.skeleton {
  height: 5.4rem;
}

.display4 {
  font-size: 3.5rem;
}
.display4.skeleton {
  height: 4.2rem;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
